module.exports = __webpack_public_path__ + "static/img/1-1.6fead2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1-1.png
// module id = VOE+
// module chunks = 1